function Footer(){
    const footer = 
        <footer className="copyright">
            <p>©2023 All rights reserved</p>
        </footer>
    return footer
}

export default Footer